import AdminDonutTooltip from './component'
export default AdminDonutTooltip
